import {isRTL} from '../../../../Localization';

const en = {
    backTo: 'Back to list',
    addLabel: 'Add'
};

const he = {
    backTo: 'חזרה לרשימה',
    addLabel: 'הוספת'
};

export const texts = isRTL() ? he : en;
